/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TrendComparisonType = {
    PreviousPeriod: 'previous_period',
    SamePeriodLastYear: 'same_period_last_year',
    PeriodsAgo: 'periods_ago',
    StaticNumber: 'static_number'
} as const;
export type TrendComparisonType = typeof TrendComparisonType[keyof typeof TrendComparisonType];

